<template>
  <div id="contenedor-listado-mobiles">
    <template v-for="(adjudicacionDirecta, index) in listadoAdjudicacionesDirectas">
      <v-card :key="index" class="mb-2">
        <v-card-title class="justify-space-between">
          <div class="d-inline-block text-truncate">
            {{ adjudicacionDirecta.numeroContrato }}
          </div>
          <div class="d-inline-block">
            <opciones :adjudicacionDirecta="adjudicacionDirecta"> </opciones>
          </div>
        </v-card-title>
        <v-card-text>
          {{ adjudicacionDirecta.meta }}
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>

import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoAdjudicacionesDirectas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
